<div class="icon-container" [style.width]="iconWidth()" [style.height]="iconHeight()"
  [style.background]="iconConfig()?.background || 'transparent'" 
  [class.strokeChange]="hasStrokeKey()"
  [class.fillChange]="hasFillKey()"
  [style.--icon-stroke]="iconStroke() || null"
  [style.--icon-fill]="iconFill() || null"
  >
  @if (useImgFallback && iconImgSrc) {
    <img class="status-icon-img" [src]="iconImgSrc" [alt]="iconConfig()?.icon || 'status icon'">
  } @else {
    <mat-icon [svgIcon]="iconConfig()?.icon"

    [style.fill]="iconConfig()?.fill ? iconConfig()?.fill + ' !important' : ''"></mat-icon>
  }
  <!-- {{ hasStrokeKey() }} -->
</div>